<sm-title-bar pageTitle="Subscription" [headerCustomTemplate]="searchBar">
  <ng-template #searchBar>
    <div class="d-flex search-field">
      <mat-form-field appearance="outline" class="me-2">
        <mat-label>Enter Phone Number</mat-label>
        <input
          matInput
          type="tel"
          maxlength="13"
          [formControl]="searchInput"
          placeholder="Include area code, e.g. (+91)"
        />
        <button
          mat-button
          *ngIf="searchInput.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="searchInput.reset()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <button
        mat-flat-button
        color="accent"
        [disabled]="searchInput.invalid || isFetching"
        (click)="onGetSubscription()"
      >
        Get details
      </button>
    </div>
  </ng-template>
</sm-title-bar>

<div *ngIf="isFetching" class="loader">
  <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="subscriptionData && !isFetching && !allNull">
  <mat-card class="subscription-info">
    <mat-card-header class="row flex-wrap">
      <!-- <div class="row"> -->
        <div class="col-md-1 subsicon">
          <mat-icon mat-card-avatar class="material-icons-round">
            card_membership
          </mat-icon>
        </div>
        <div class="col-md-8">
         
          <mat-card-title>Subscription Info</mat-card-title>
          <mat-card-subtitle
            ><small
              >The current subscription details of the user are given below.</small
            ></mat-card-subtitle
          >
        </div>
        <div class="col-md-3">
  
      
          
            <button
          mat-flat-button
          color="accent"
          class= "addFreeSub"
          (click)="addFreeSubscription()"
         >
       Add free subscription
        </button>
          
        </div>
      <!-- </div> -->
    
      
    </mat-card-header>
    <mat-card-content>
      <div class="row row-cols-md-4 row-cols-1 g-3">
        <div class="col p-md-3">
          <div class="info">
            <h4>Owner name:</h4>
            <p>{{subscriptionData.ownerName!= null ? subscriptionData.ownerName : '-'}}</p>
          </div>
        </div>
        <div class="col p-md-3">
          <div class="info">
            <h4>Available business add credit:</h4>
            <p>{{ businessAddCredit }}</p>
          </div>
        </div>
        <div class="col p-md-3">
          <div class="info">
            <h4>Available employee add credit:</h4>
            <p>{{ employeeAddCredit }}</p>
          </div>
        </div>
        <div class="col p-md-3">
          <div class="info">
            <h4>Subscription by referring:</h4>
            <p>0</p>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="stat-cards row row-cols-md-3 row-cols-1 gx-4 mt-4">
    <div class="col" >
      <mat-card>
        <mat-card-content>
          <h2 class="mb-0">Business subscription</h2>
          <p>
            <small
              >Lorem, ipsum dolor sit amet consectetur adipisicing elit.</small
            >
          </p>
          <h1>{{subscriptionData.businessSubsInfo!= null ? subscriptionData.businessSubsInfo.length : 0 }}</h1>
        </mat-card-content>
        <mat-card-actions class="text-end">
          <button
            mat-button
            [routerLink]="['/subscription', 'businesses']"
            
            queryParamsHandling="preserve"
          >
            View details
            <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="col mt-4 mt-md-0" >
      <mat-card>
        <mat-card-content>
          <h2 class="mb-0">Employee subscription</h2>
          <p>
            <small
              >Lorem, ipsum dolor sit amet consectetur adipisicing elit.</small
            >
          </p>
          <h1>{{subscriptionData.userSubsInfo!= null ? subscriptionData.userSubsInfo.length : 0 }}</h1>
        </mat-card-content>
        <mat-card-actions class="text-end">
          <button
            mat-button
            [routerLink]="['/subscription', 'employees']"
            [skipLocationChange]="true"
            queryParamsHandling="preserve"
          >
            View details
            <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="col mt-4 mt-md-0" >
      <mat-card>
        <mat-card-content>
          <h2 class="mb-0">Number of transaction</h2>
          <p>
            <small
              >Lorem, ipsum dolor sit amet consectetur adipisicing elit.</small
            >
          </p>
          <h1>{{subscriptionData.transInfo !=null ? subscriptionData.transInfo.length : 0 }}</h1>
        </mat-card-content>
        <mat-card-actions class="text-end">
          <button
            mat-button
            [routerLink]="['/subscription', 'transactions']"
            [skipLocationChange]="true"
            queryParamsHandling="preserve"
          >
            View details
            <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="subscriptionData === null && !isFetching">
  <div class="py-5 text-center">
    <h3 class="text-muted">No data found</h3>
  </div>
</ng-container>

<ng-container *ngIf="allNull  && !isFetching">
  <div class="py-5 text-center">
    <h3 class="text-muted">No data found</h3>
  </div>
</ng-container>
